import React from 'react';
import { ArrowUpRight, Globe, MapPin, Phone } from 'lucide-react';
export function Footer() {
  const links = [{
    label: 'Studio',
    href: '#studio'
  }, {
    label: 'Capabilities',
    href: '#services'
  }, {
    label: 'Client stories',
    href: '#testimonials'
  }, {
    label: 'Contact',
    href: '#contact'
  }];
  return <footer className="border-t border-white/5 bg-dark-darker pb-10 pt-16" data-id="element-79">
      <div className="mx-auto max-w-[1320px] px-4" data-id="element-80">
        <div className="grid gap-12 md:grid-cols-[1.3fr_0.8fr_1fr]" data-id="element-81">
          <div data-id="element-82">
            <a href="#home" className="mb-6 inline-block" aria-label="Byteweb home" data-id="element-83">
              <img src="https://cdn.magicpatterns.com/uploads/5NTyxseHUpDeTNPmLZNFKL/ByteWeb8.png" alt="Byteweb" className="h-11 w-auto" data-id="element-84" />
            </a>
            <p className="max-w-sm font-inter leading-relaxed text-white/60" data-id="element-85">
              Byteweb is a Cape Town digital studio helping organisations turn
              ambitious ideas into useful, high-performing digital experiences.
            </p>
          </div>

          <div data-id="element-86">
            <h2 className="mb-5 font-syne text-lg font-bold text-white" data-id="element-87">
              Explore
            </h2>
            <ul className="space-y-3" data-id="element-88">
              {links.map(link => <li key={link.label} data-id="element-89">
                  <a href={link.href} className="font-inter text-sm text-white/60 transition-colors hover:text-gold" data-id="element-90">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-91">
            <h2 className="mb-5 font-syne text-lg font-bold text-white" data-id="element-92">
              Studio details
            </h2>
            <div className="space-y-4 font-inter text-sm text-white/60" data-id="element-93">
              <a href="tel:+27712158291" className="flex items-center gap-3 transition-colors hover:text-gold" data-id="element-94">
                <Phone size={16} className="text-gold" data-id="element-95" />
                071 215 8291
              </a>
              <p className="flex items-center gap-3" data-id="element-96">
                <MapPin size={16} className="text-gold" data-id="element-97" />
                Cape Town, South Africa
              </p>
              <a href="https://byteweb.co.za/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 transition-colors hover:text-gold" data-id="element-98">
                <Globe size={16} className="text-gold" data-id="element-99" />
                byteweb.co.za
                <ArrowUpRight size={14} data-id="element-100" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 border-t border-white/5 pt-8 text-center" data-id="element-101">
          <p className="font-inter text-sm text-white/40" data-id="element-102">
            © {new Date().getFullYear()} Byteweb. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}